export default __webpack_public_path__ + "4d53de7ab4f46c1d5066cc46a50d5b9c.svg";